module.exports = __webpack_public_path__ + "static/media/all.3f447109.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/UnifiedMessaging/all.svg
// module id = 1846
// module chunks = 0